import api from './api';
import {
  InventoryItem,
  InventoryCategory,
  InventoryTransaction,
  InventoryStockAlert,
  InventoryStats,
  StockAdjustment,
} from '../types/inventory';

export const inventoryAPI = {
  // Categories
  getCategories: () => api.get<InventoryCategory[]>('/inventory/categories'),
  
  createCategory: (data: Partial<InventoryCategory>) =>
    api.post<InventoryCategory>('/inventory/categories', data),
  
  updateCategory: (id: number, data: Partial<InventoryCategory>) =>
    api.put<InventoryCategory>(`/inventory/categories/${id}`, data),
  
  deleteCategory: (id: number) =>
    api.delete(`/inventory/categories/${id}`),

  // Items
  getItems: (params?: {
    category_id?: number;
    search?: string;
    low_stock?: boolean;
    page?: number;
    limit?: number;
  }) => api.get<InventoryItem[]>('/inventory/items', { params }),
  
  getItem: (id: number) =>
    api.get<InventoryItem>(`/inventory/items/${id}`),
  
  createItem: (data: Partial<InventoryItem>) =>
    api.post<InventoryItem>('/inventory/items', data),
  
  updateItem: (id: number, data: Partial<InventoryItem>) =>
    api.put<InventoryItem>(`/inventory/items/${id}`, data),
  
  deleteItem: (id: number) =>
    api.delete(`/inventory/items/${id}`),
  
  // Stock management
  adjustStock: (itemId: number, adjustment: StockAdjustment) =>
    api.post(`/inventory/items/${itemId}/adjust-stock`, adjustment),
  
  getLowStockItems: () =>
    api.get<InventoryItem[]>('/inventory/low-stock'),
  
  // Transactions
  createTransaction: (data: Partial<InventoryTransaction>) =>
    api.post<InventoryTransaction>('/inventory/transactions', data),
  
  getTransactions: (params?: {
    item_id?: number;
    transaction_type?: string;
    start_date?: string;
    end_date?: string;
    page?: number;
    limit?: number;
  }) => api.get<InventoryTransaction[]>('/inventory/transactions', { params }),
  
  // Stock alerts
  getStockAlerts: (acknowledged?: boolean) =>
    api.get<InventoryStockAlert[]>('/inventory/alerts', {
      params: { acknowledged },
    }),
  
  acknowledgeAlert: (id: number) =>
    api.post(`/inventory/alerts/${id}/acknowledge`),
  
  // Reports and stats
  getStats: () =>
    api.get<InventoryStats>('/inventory/stats'),
  
  exportInventory: () =>
    api.get('/inventory/export', {
      responseType: 'blob',
    }),
};